import React, {useState, useEffect} from "react";
import { useCart } from "react-use-cart";
import {useNavigate} from "react-router-dom"
import axios from "axios";
import {Navbar} from 'react-bootstrap'
import './cart.css'
import {BsFillCartXFill} from 'react-icons/bs'
import { useIdleTimer } from 'react-idle-timer'
import Swal from "sweetalert2";
import ScaleLoader from "react-spinners/ScaleLoader";

const Cart = () => {
  const [loading, setLoading] = useState(false)

    useEffect(() => {
        setLoading(true)
        setTimeout( () => {
            setLoading(false)
        },800)

    },[])
  
    const navigate = useNavigate()
    // const [product_id, setProduct_id] = useState()
    // const [quantity, setQuantity] = useState()

    const handleOnIdle = () => {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'You were idle for too long!',
      })
      navigate('/idle')
    }
  
 useIdleTimer({
      timeout: 1000 * 60 * 10,
      onIdle: handleOnIdle,
    })

    const {
      isEmpty,
      items,
      updateItemQuantity,
      removeItem,
      cartTotal,
      emptyCart
    } = useCart();

  
    if (isEmpty) return (
      <div className='emptyCart'>
      <div style={{backgroundColor: '#F7931E', position: 'relative', width: '100vw', height: '100vh'}}>
      
        <h2 className="word">Your cart is empty</h2>
        <BsFillCartXFill style={{height: 150, width: 150, color:'white'}}/>
        <br></br>
        <button className="back" onClick={()=>navigate('/Browse')}>Browse Menu</button>
    </div>
    </div>
    )

    
    const checkOut = () => {
      const closed_by = "BT001"
      const date_of_addition = JSON.stringify(new Date())
      const order_status = "pending"
      const table_id = localStorage.getItem('tableid')
      console.log(table_id)
      if(table_id === 'Employee'){
        throw alert('Get out of my Swamp you minimum wage worker!!!')
      }if(table_id === null) {
        throw alert('Please Scan the QR again')
      }
      
      //const tableid = [1,2,3,4,5,6]
      //const table_id = tableid[Math.floor(Math.random() * tableid.length)];
      const products = localStorage.getItem('react-use-cart')
      
      console.log(date_of_addition)
      axios.post('https://peaceful-garden-23768.herokuapp.com/api/order/submitorder', {
       closed_by,
       date_of_addition,
       order_status,
       table_id
      
       
     })
     .then(response => {
      
       var cartItems = JSON.parse(products).items
       const order_id = response.data.rows[0].order_id
       
       localStorage.setItem('orderid', order_id)
      axios.post('https://peaceful-garden-23768.herokuapp.com/api/order/checkout',{
        cartItems,
        order_id,
     })}
       
    )
     .then(function(){
      emptyCart()
      navigate('/success')
      localStorage.removeItem('react-use-cart')

     })
     
    .catch(()=>{
      Swal.fire({
        icon: 'error',
        title: 'Error!',
        text: 'Place order Unsuccessful',
      })
    })
     
    }

  
    
    return (
      <div className="parent"> 
       { loading ?  
            <div className='spinner'>
            <ScaleLoader color={'#ffa500'} loading={loading} size={30}/>
            </div>
           :  
           <div>
                  <div>
                  <Navbar style={{background: '#ffa500', display: 'flex', justifyContent: 'space-between'}}>  
                  <h3 style={{color:'white',  marginLeft:20 }}>Burger Tech</h3>
                  </Navbar>
                    </div>

                    <div className="container">
                      {items.map((item) => (
                        <div key={item.id} className="row mb-3 cartRow">
                          <div className="col-4 cartItem"> 
                            <div>
                              <div>{item.name}</div> 
                              <div>Price: ${item.price}</div>
                            </div>
                          </div>
                          <div className="col-3 cartQuantity">
                            <button
                              onClick={() => updateItemQuantity(item.id, item.quantity - 1)} style={{background: 'white', border: '1px solid white', color: '#F7931E', borderRadius: '15px',  fontWeight: 'bold', outline: 0 }}
                            >
                              -
                            </button>
                            <div>{item.quantity}</div>
                            <button 
                              onClick={() => updateItemQuantity(item.id, item.quantity + 1)}  style={{background: 'white', border: '1px solid white', color: '#F7931E', borderRadius: '15px', fontWeight: 'bold', outline: 0 }}
                            >
                              +
                            </button>
                          </div>
                          <div className="col-2">
                            ${item.price * item.quantity}
                          </div>
                          <div className="col-2">
                            <button onClick={() => removeItem(item.id)} style={{background: 'white', border: '1px solid white', color: 'red', borderRadius: '15px', padding: '15px 3px', fontWeight: 'bold', outline: 0 }}>Remove </button>
                            
                          </div>
                        </div>
                      ))}
                    </div>

                    <div className="GST">
                        <div>GST (7%):</div>
                        <div>${(cartTotal*0.07).toFixed(2)}</div>
                    </div>

                    <div className="service">
                        <div>Service Charge (10%):</div>
                        <div>${(cartTotal*0.1).toFixed(2)}</div>
                    </div>

                    <div className="subTotal">
                        <div>SubTotal:</div>
                        <div>${cartTotal.toFixed(2)}</div>
                    </div>

                    <div className="Total">
                        <div>Total (SGD):</div>
                        <div>${(cartTotal +(cartTotal*0.07)+ (cartTotal*0.1)).toFixed(2)}</div>
                    </div>
                    
                    <div className="twobuttons">
                        <button className="back1" onClick={()=>navigate('/Browse')}>Cancel</button>
                      
                        <button className="place" onClick={checkOut}>Place Order</button>
                  </div>
                  </div>
        }
      </div>
    );
  }

export default Cart